import React from 'react';
import { useAlert } from '../../AlertProvider';

import { Box, Divider } from '@mui/material';
import { DateFormats, providerScheduleViewTypeRoute } from '@uplift/constants';
import { useCurrentuser, useTimezone } from '@uplift/contexts';
import { useBookingSlotsQuery } from '@uplift/queries';
import { CalendarDateService, DateObject } from '@uplift/services';

import { Button } from '../../Button';
import { AddSessionFormFormikMobile } from '../../molecules';
import { useIsCurrentProviderLive } from '@uplift/hooks';

export type CreateAppointmentProps = {
  date: string;
  getAvailableBookingSlotRange: (date: DateObject, availableSlots?: Set<string>) => Promise<{start: string; end: string}>;
  reloadEvents: () => Promise<void>;
};


const AddSessionModal: React.FC<{
  newEvent?: { start: string; end: string };
  onClose: () => void;
  reloadEvents: () => Promise<void>;
}> = ({ newEvent, onClose, reloadEvents }) => {
  return (
    <AddSessionFormFormikMobile
      key={newEvent?.start}
      open={!!newEvent}
      onClose={onClose}
      onSuccess={async () => {
        await reloadEvents();
        onClose?.();
      }}
      newEvent={newEvent}
    />
  );
};


export const CreateAppointment: React.FC<CreateAppointmentProps> = ({ date, getAvailableBookingSlotRange, reloadEvents }) => {
  const alert = useAlert();
  const timezone = useTimezone();
  const [ newEvent, setNewEvent ] = React.useState<{ start: string; end: string }>();
  const { data: bookingSlots } = useBookingSlotsQuery(date, timezone);
  const me = useCurrentuser();
  const allowToCreateAppointments = useIsCurrentProviderLive(me);

  const handleClick = () => {
    if (date) {
      const dateObj = CalendarDateService.date.tz(date, DateFormats.ISO_DATE, timezone);

      getAvailableBookingSlotRange(dateObj, bookingSlots)
        .then(setNewEvent)
        .catch(err => {
          alert.error('No available slots for this day, please choose another day');
          console.log(' >>> ERROR APPOINTMENT CREATION', err);
        });
    }
  };

  const shouldInviteNewClient = providerScheduleViewTypeRoute.useQueryParam('createAppointment') === 'invite';

  React.useEffect(() => {
    if (shouldInviteNewClient && bookingSlots?.size && bookingSlots.size > 0) {
      handleClick();
    }
  }, [ bookingSlots ]);

  return (
    <>
      <Divider />
      <Box p={2}>
        <Button
          disabled={!allowToCreateAppointments}
          fullWidth
          variant="contained"
          color="secondary"
          onClick={handleClick}
        >
          Add sessions
        </Button>
      </Box>
      <AddSessionModal
        newEvent={newEvent}
        onClose={() => setNewEvent(undefined)}
        reloadEvents={reloadEvents}
      />
    </>
  );
};
